import React, { useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import GlobalContext from '../Context';
import GlobalReducer from '../Reducer';
import {
  SET_ORIGIN,
  SET_REDIRECT_URL,
  SET_PUBLICKEY,
  SET_IS_CITA_FLOW,
  SET_BUTTON_URL,
  SET_CUSTOMER_ID,
  SET_CART_COUNTRY,
  SET_APPOINTMENT_DATE,
  SET_APPOINTMENT_CENTER,
} from '../types';

const GlobalState = ({ children }) => {
  const initialstate = {
    origin: '',
    redirectUrl: '',
    publicKey: '',
    isCitaFlow: false,
    buttonUrl: '',
    customerId: '',
    country: '',
    appointmentDate: '',
    appointmentCenter: '',
  };

  const [state, dispatch] = useReducer(GlobalReducer, initialstate);

  const setOriginFunction = (origin) => {
    localStorage.setItem('origin', origin);
    dispatch({
      type: SET_ORIGIN,
      payload: origin,
    });
  };

  const setRedirectUrlFunction = (url) => {
    localStorage.setItem('redirectUrl', url);
    dispatch({
      type: SET_REDIRECT_URL,
      payload: url,
    });
  };

  const setPublicKeyFunction = (publicKey) => {
    localStorage.setItem('publicKey', publicKey);
    dispatch({
      type: SET_PUBLICKEY,
      payload: publicKey,
    });
  };

  const setIsCitaFlowFunction = (value) => {
    localStorage.setItem('isCitaFlow', value);
    dispatch({
      type: SET_IS_CITA_FLOW,
      payload: value,
    });
  };

  const setButtonUrlFunction = (url) => {
    localStorage.setItem('buttonUrl', url);
    dispatch({
      type: SET_BUTTON_URL,
      payload: url,
    });
  };

  const setCustomerIdFunction = (customer) => {
    dispatch({
      type: SET_CUSTOMER_ID,
      payload: customer,
    });
  };

  const setCartCountryFunction = (country) => {
    dispatch({
      type: SET_CART_COUNTRY,
      payload: country,
    });
  };

  const setAppointmentDateFunction = (date) => {
    localStorage.setItem('appointmentDate', date);
    dispatch({
      type: SET_APPOINTMENT_DATE,
      payload: date,
    });
  };

  const setAppointmentCenterFunction = (center) => {
    localStorage.setItem('appointmentCenter', center);
    dispatch({
      type: SET_APPOINTMENT_CENTER,
      payload: center,
    });
  };

  const contextValue = useMemo(() => {
    return {
      origin: state.origin,
      redirectUrl: state.redirectUrl,
      publicKey: state.publicKey,
      isCitaFlow: state.isCitaFlow,
      buttonUrl: state.buttonUrl,
      customerId: state.customerId,
      country: state.country,
      appointmentDate: state.appointmentDate,
      appointmentCenter: state.appointmentCenter,
      setOriginFunction,
      setRedirectUrlFunction,
      setPublicKeyFunction,
      setIsCitaFlowFunction,
      setButtonUrlFunction,
      setCustomerIdFunction,
      setCartCountryFunction,
      setAppointmentDateFunction,
      setAppointmentCenterFunction,
    };
  }, [
    state.origin,
    state.redirectUrl,
    state.publicKey,
    state.isCitaFlow,
    state.buttonUrl,
    state.customerId,
    state.country,
    state.appointmentDate,
    state.appointmentCenter,
    setOriginFunction,
    setRedirectUrlFunction,
    setPublicKeyFunction,
    setIsCitaFlowFunction,
    setButtonUrlFunction,
    setCustomerIdFunction,
    setCartCountryFunction,
  ]);

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalState;

GlobalState.propTypes = {
  children: PropTypes.node.isRequired,
};
